import { Box, Flex, Skeleton, Text } from '@chakra-ui/react';

import { Filters, UriFilter } from '~/features/catalog/models/filter';
import { CatalogFilters } from '~/features/experiments/ab_plp_redesign_2025/components/catalog-filters';
import { useI18n } from '~/hooks/use-i18n';

import { CatalogSearchSort } from './catalog-search-sort';

export function CatalogSearchResultsToolbar({
  isLoading,
  numberOfResults,
  numberOfSelectedFilters,
  selectedFilters,
  skillUriFilters,
}: {
  isLoading: boolean;
  numberOfResults?: number;
  numberOfSelectedFilters: number;
  selectedFilters: Filters;
  skillUriFilters: UriFilter[];
}) {
  const { t, i18n } = useI18n();
  // Hide the count while a new query is in flight so it never flashes "0 programs found".
  const settledCount = isLoading ? undefined : numberOfResults;

  return (
    <Flex
      alignItems='center'
      flexWrap='nowrap'
      gap='8px'
      justifyContent='space-between'
      minHeight='38px'
      minW={0}
      w='100%'
    >
      <Skeleton
        flex={settledCount !== undefined ? '1 1 auto' : '0 0 auto'}
        isLoaded={settledCount !== undefined}
        minW={0}
        overflow='hidden'
        w={settledCount !== undefined ? undefined : '120px'}
      >
        <Flex alignItems='baseline' aria-live='polite' gap='4px' minW={0} overflow='hidden'>
          <Text as='span' color='grey.900' flexShrink={0} fontSize='0.875rem' fontWeight='600' lineHeight='22px'>
            {(settledCount ?? 0).toLocaleString(i18n.language)}
          </Text>
          <Text
            as='span'
            color='grey.500'
            flex='1 1 auto'
            fontSize='0.75rem'
            lineHeight='18px'
            minW={0}
            overflow='hidden'
            textOverflow='ellipsis'
            whiteSpace='nowrap'
          >
            {t('catalog.programsFound', { count: settledCount ?? 0 })}
          </Text>
        </Flex>
      </Skeleton>
      <Box display={{ base: 'none', lg: 'block' }} flexShrink={0}>
        <CatalogSearchSort />
      </Box>
      <Box display={{ base: 'block', lg: 'none' }} flexShrink={0}>
        <CatalogFilters
          isLoading={isLoading}
          numberOfResults={numberOfResults}
          numberOfSelectedFilters={numberOfSelectedFilters}
          selectedFilters={selectedFilters}
          skillUriFilters={skillUriFilters}
        />
      </Box>
    </Flex>
  );
}
